export const currenciesOptions = [
  { value: "USD", label: "USD ($)" },
  { value: "CAD", label: "CAD (CA$)" },
  { value: "EUR", label: "EUR (€)" },
  { value: "AED", label: "AED (AED)" },
  { value: "AFN", label: "AFN (Af)" },
  { value: "ALL", label: "ALL (ALL)" },
  { value: "AMD", label: "AMD (AMD)" },
  { value: "ARS", label: "ARS (AR$)" },
  { value: "AUD", label: "AUD (AU$)" },
  { value: "AZN", label: "AZN (man.)" },
  { value: "BAM", label: "BAM (KM)" },
  { value: "BDT", label: "BDT (Tk)" },
  { value: "BGN", label: "BGN (BGN)" },
  { value: "BHD", label: "BHD (BD)" },
  { value: "BIF", label: "BIF (FBu)" },
  { value: "BND", label: "BND (BN$)" },
  { value: "BOB", label: "BOB (Bs)" },
  { value: "BRL", label: "BRL (R$)" },
  { value: "BWP", label: "BWP (BWP)" },
  { value: "BYN", label: "BYN (Br)" },
  { value: "BZD", label: "BZD (BZ$)" },
  { value: "CDF", label: "CDF (CDF)" },
  { value: "CHF", label: "CHF (CHF)" },
  { value: "CLP", label: "CLP (CL$)" },
  { value: "CNY", label: "CNY (CN¥)" },
  { value: "COP", label: "COP (CO$)" },
  { value: "CRC", label: "CRC (₡)" },
  { value: "CVE", label: "CVE (CV$)" },
  { value: "CZK", label: "CZK (Kč)" },
  { value: "DJF", label: "DJF (Fdj)" },
  { value: "DKK", label: "DKK (Dkr)" },
  { value: "DOP", label: "DOP (RD$)" },
  { value: "DZD", label: "DZD (DA)" },
  { value: "EEK", label: "EEK (Ekr)" },
  { value: "EGP", label: "EGP (EGP)" },
  { value: "ERN", label: "ERN (Nfk)" },
  { value: "ETB", label: "ETB (Br)" },
  { value: "GBP", label: "GBP (£)" },
  { value: "GEL", label: "GEL (GEL)" },
  { value: "GHS", label: "GHS (GH₵)" },
  { value: "GNF", label: "GNF (FG)" },
  { value: "GTQ", label: "GTQ (GTQ)" },
  { value: "HKD", label: "HKD (HK$)" },
  { value: "HNL", label: "HNL (HNL)" },
  { value: "HRK", label: "HRK (kn)" },
  { value: "HUF", label: "HUF (Ft)" },
  { value: "IDR", label: "IDR (Rp)" },
  { value: "ILS", label: "ILS (₪)" },
  { value: "INR", label: "INR (Rs)" },
  { value: "IQD", label: "IQD (IQD)" },
  { value: "IRR", label: "IRR (IRR)" },
  { value: "ISK", label: "ISK (Ikr)" },
  { value: "JMD", label: "JMD (J$)" },
  { value: "JOD", label: "JOD (JD)" },
  { value: "JPY", label: "JPY (¥)" },
  { value: "KES", label: "KES (Ksh)" },
  { value: "KHR", label: "KHR (KHR)" },
  { value: "KMF", label: "KMF (CF)" },
  { value: "KRW", label: "KRW (₩)" },
  { value: "KWD", label: "KWD (KD)" },
  { value: "KZT", label: "KZT (KZT)" },
  { value: "LBP", label: "LBP (L.L.)" },
  { value: "LKR", label: "LKR (SLRs)" },
  { value: "LTL", label: "LTL (Lt)" },
  { value: "LVL", label: "LVL (Ls)" },
  { value: "LYD", label: "LYD (LD)" },
  { value: "MAD", label: "MAD (MAD)" },
  { value: "MDL", label: "MDL (MDL)" },
  { value: "MGA", label: "MGA (MGA)" },
  { value: "MKD", label: "MKD (MKD)" },
  { value: "MMK", label: "MMK (MMK)" },
  { value: "MOP", label: "MOP (MOP$)" },
  { value: "MUR", label: "MUR (MURs)" },
  { value: "MXN", label: "MXN (MX$)" },
  { value: "MYR", label: "MYR (RM)" },
  { value: "MZN", label: "MZN (MTn)" },
  { value: "NAD", label: "NAD (N$)" },
  { value: "NGN", label: "NGN (₦)" },
  { value: "NIO", label: "NIO (C$)" },
  { value: "NOK", label: "NOK (Nkr)" },
  { value: "NPR", label: "NPR (NPRs)" },
  { value: "NZD", label: "NZD (NZ$)" },
  { value: "OMR", label: "OMR (OMR)" },
  { value: "PAB", label: "PAB (B/.)" },
  { value: "PEN", label: "PEN (S/.)" },
  { value: "PHP", label: "PHP (₱)" },
  { value: "PKR", label: "PKR (PKRs)" },
  { value: "PLN", label: "PLN (zł)" },
  { value: "PYG", label: "PYG (₲)" },
  { value: "QAR", label: "QAR (QR)" },
  { value: "RON", label: "RON (RON)" },
  { value: "RSD", label: "RSD (din.)" },
  { value: "RUB", label: "RUB (RUB)" },
  { value: "RWF", label: "RWF (RWF)" },
  { value: "SAR", label: "SAR (SR)" },
  { value: "SDG", label: "SDG (SDG)" },
  { value: "SEK", label: "SEK (Skr)" },
  { value: "SGD", label: "SGD (S$)" },
  { value: "SOS", label: "SOS (Ssh)" },
  { value: "SYP", label: "SYP (SY£)" },
  { value: "THB", label: "THB (฿)" },
  { value: "TND", label: "TND (DT)" },
  { value: "TOP", label: "TOP (T$)" },
  { value: "TRY", label: "TRY (TL)" },
  { value: "TTD", label: "TTD (TT$)" },
  { value: "TWD", label: "TWD (NT$)" },
  { value: "TZS", label: "TZS (TSh)" },
  { value: "UAH", label: "UAH (₴)" },
  { value: "UGX", label: "UGX (USh)" },
  { value: "UYU", label: "UYU ($U)" },
  { value: "UZS", label: "UZS (UZS)" },
  { value: "VEF", label: "VEF (Bs.F.)" },
  { value: "VND", label: "VND (₫)" },
  { value: "XAF", label: "XAF (FCFA)" },
  { value: "XOF", label: "XOF (CFA)" },
  { value: "YER", label: "YER (YR)" },
  { value: "ZAR", label: "ZAR (R)" },
  { value: "ZMK", label: "ZMK (ZK)" },
  { value: "ZWL", label: "ZWL (ZWL$)" },
] as const;
